<template>
  <div class="project">
    <div class="project-box">
      <div class="project-list-left">
        <div class="project-list-top">
          <div class="top-left">
            <img src="../../assets/img/project-img.png" />
          </div>
          <div class="top-right">项目年份</div>
        </div>
        <div class="project-list-content">
          <div class="project-list-ome">
            <div
              class="project-list-text"
              v-for="(item,index) in projectList"
              :key="index"
              :class="activeIndex == index?'activeSelect': ''"
              @click="toSearch(item,index)"
            >
              {{item.projectYear}}
              <span>（{{item.projectCount}}）</span>
            </div>
          </div>
        </div>
      </div>
      <div class="project-list-right">
        <div class="project-right-top">
          <div class="project-header-left">{{orgName}}</div>
          <div class="project-header-right" @click="goBack" v-show="hasBtn">返回区域列表</div>
        </div>
        <div class="project-right-content" v-if="flag">
          <div class="right-content">
            <div
              class="right-content-one"
              v-for="(item,index) in caseList"
              :key="index"
              @click="toProject(item)"
            >{{item.projectName}}</div>
          </div>
          <div class="page-box">
            <el-pagination
              background
              @current-change="handleSizeChange"
              :current-page.sync="pageNo"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <div class="project-none" v-else>
          <div style="text-align: center;">
            <img src="../../assets/img/peoject-none.png" />
            <div style="color:#999999;font-size: 13px;">本年份暂无项目信息</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  queryPublicityProjectListIndex,
  queryPublicityProjectPage
} from '@/api/publicinquiry.api.js';
import { setSession, getSession } from '@/untils';
export default {
  computed: {
    flag() {
      return this.caseList.length > 0;
    },
    hasBtn() {
      return this.isShow === 2;
    }
  },
  data() {
    return {
      projectList: [],
      activeIndex: 0,
      caseList: [],
      total: 0,
      pageNo: 1,
      pageSize: 5,
      orgId: '',
      year: '',
      orgName: '',
      isShow: ''
    };
  },
  methods: {
    handleSizeChange(page) {
      this.pageNo = page;
      this.getList();
    },
    getYearList() {
      let params = {
        orgId: this.orgId
      };
      queryPublicityProjectListIndex(params).then(res => {
        if (res.body) {
          this.projectList = res.body;
          this.year = this.projectList[0].projectYear;
          this.getList();
        }
      });
    },
    getList() {
      let params = {
        year: this.year,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orgId: this.orgId
      };
      queryPublicityProjectPage(params).then(res => {
        this.caseList = res.body.records;
        this.total = res.body.total;
      });
    },
    toSearch(item, index) {
      this.pageNo = 1;
      this.year = item.projectYear;
      this.activeIndex = index;
      this.getList();
    },
    goBack() {
      this.$router.push({ name: 'public' });
    },
    toProject(item) {
      setSession('projectId', item.projectId);
      setSession('newOrgName', item.orgName);
      setSession('projectName', item.projectName);
      this.$router.push({
        name: 'projecthome'
      });
    }
  },
  created() {
    this.orgId = getSession('orgId');
    this.orgName = getSession('orgName');
    this.isShow = getSession('isShow');
    this.getYearList();
  }
};
</script>
<style scoped>
.project {
  height: 100%;
}
.project-box {
  height: 100%;
  background: #ffffff;
  display: flex;
}
.project-list-left {
  height: 100%;
  width: 13%;
  /* border-right: 2px solid rgba(2, 91, 145, 1); */
}
.project-list-right {
  width: 87%;
  height: 100%;
  border-left: 2px solid rgba(2, 91, 145, 1);
}
.project-right-content {
  /* border-left: 2px solid rgba(2, 91, 145, 1); */
}
.project-list-top {
  display: flex;
  height: 40px;
  background: rgba(2, 91, 145, 1);
}
.top-right {
  text-align: center;
  color: #ffffff;
  padding: 10px;
}
.top-left {
  padding: 14px;
}
.top-left img {
  width: 16px;
}
.project-list-text {
  text-align: center;
  padding: 10px 0px;
}
.project-list-text:hover {
  background: rgb(224, 245, 255);
  cursor: pointer;
}
.activeSelect {
  background: rgb(224, 245, 255);
}
.project-right-content {
  overflow: auto;
  height: calc(100% - 53px);
}
.project-list-content {
  overflow: auto;
  height: calc(100% - 53px);
}
.right-content {
  padding: 0px 10px;
}
.right-content-one {
  cursor: pointer;
  margin-top: 20px;
  height: 70px;
  background: rgb(224, 245, 255);
  line-height: 70px;
  text-indent: 15px;
}
.project-right-top {
  color: rgb(2, 91, 145);
  text-indent: 15px;
  border-bottom: 2px solid rgb(2, 91, 145);
  height: 45px;
}
.project-header-left {
  float: left;
  padding: 10px 0;
  font-weight: 600;
}
.project-header-right {
  width: 110px;
  float: right;
  height: 30px;
  line-height: 30px;
  background: inherit;
  background-color: rgba(2, 91, 145, 1);
  border: none;
  border-top: 0px;
  border-radius: 10px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.right-content-one:hover {
  color: #025b91;
}
.right-content-one:hover {
  background: rgb(253, 245, 230);
}
.page-box {
  text-align: right;
  margin-top: 30px;
  padding-bottom: 30px;
}
.project-none {
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.project-none img {
  width: 50px;
}
</style>
<style media="screen">
/*分辨率低于1440，采用下面的样式*/
@media screen and (max-device-height: 800px) {
  .right-content-one {
    margin-top: 20px !important;
    height: 50px !important;
    line-height: 50px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/projectList/index.vue